import React from "react";
import { X } from "lucide-react";

export function Window({ title, children, actions, onClose }) {
  return (
    <div className="vb-window" data-testid="vb-window">
      <div className="vb-titlebar">
        <span className="flex items-center gap-2">{title}</span>
        <div className="flex items-center gap-2">
          {actions}
          {onClose && (
            <button
              onClick={onClose}
              className="vb-btn"
              style={{ padding: "1px 6px", lineHeight: 1 }}
              data-testid="window-close-btn"
            >
              <X className="w-3 h-3" />
            </button>
          )}
        </div>
      </div>
      <div className="vb-content">{children}</div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    Hadir: "vb-badge-hadir",
    "Tidak Hadir": "vb-badge-tidakhadir",
    Izin: "vb-badge-izin",
    Sakit: "vb-badge-sakit",
    Terlambat: "vb-badge-terlambat",
    "Pulang Cepat": "vb-badge-terlambat",
    Pending: "vb-badge-pending",
    Approved: "vb-badge-approved",
    Rejected: "vb-badge-rejected",
    Aktif: "vb-badge-hadir",
    "Tidak Aktif": "vb-badge-tidakhadir",
    "Kontrak Selesai": "vb-badge-pending",
  };
  const cls = map[status] || "vb-badge-pending";
  return (
    <span className={`vb-badge ${cls}`} data-testid={`badge-${status}`}>
      {status}
    </span>
  );
}

export function Dialog({ open, onClose, title, children, footer, width = 500 }) {
  if (!open) return null;
  return (
    <div className="vb-dialog-overlay" data-testid="dialog-overlay">
      <div
        className="vb-dialog"
        style={{ maxWidth: width }}
        data-testid="dialog"
      >
        <div className="vb-titlebar">
          <span>{title}</span>
          <button
            onClick={onClose}
            className="vb-btn"
            style={{ padding: "1px 6px", lineHeight: 1 }}
            data-testid="dialog-close-btn"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
        <div style={{ padding: "16px", overflow: "auto", flex: 1 }}>{children}</div>
        {footer && <div className="vb-dialog-footer">{footer}</div>}
      </div>
    </div>
  );
}

export function ConfirmDialog({ open, onClose, onConfirm, title = "Konfirmasi", message }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={title}
      width={400}
      footer={
        <>
          <button className="vb-btn" onClick={onClose} data-testid="confirm-cancel">
            Batal
          </button>
          <button className="vb-btn-danger" onClick={onConfirm} data-testid="confirm-yes">
            Ya, Lanjutkan
          </button>
        </>
      }
    >
      <p style={{ fontSize: 13, margin: 0 }}>{message}</p>
    </Dialog>
  );
}

export function EmptyState({ message = "Tidak ada data" }) {
  return <div className="vb-empty" data-testid="empty-state">{message}</div>;
}

export function Loading({ message = "Memuat data..." }) {
  return <div className="vb-loading" data-testid="loading-state">{message}</div>;
}

export function StatCard({ label, value, testId, valueColor }) {
  return (
    <div className="vb-statcard" data-testid={testId}>
      <div className="vb-statcard-label">{label}</div>
      <div className="vb-statcard-value" style={valueColor ? { color: valueColor } : undefined}>{value}</div>
    </div>
  );
}
